import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';

import APDropdown from 'components/Dropdown/APDropdown';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';

import './horizontal-menu.scss';

const HorizontalMenu = ({ items, className, isResponsive=false }) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [isOpen, setIsOpen] = useState(false);

  const show = () => {
    setIsOpen(true);
  };

  const dismiss = () => {
    setIsOpen(false);
  };

  const activeItem = items.find(item => item.active);

  const TriggerButton = (
    <DropdownButton
      className={clsx(
        'select',
        'button--menu',
      )}
    >
      {activeItem ? activeItem.name : items[0].name}
    </DropdownButton>
  );

  if (isResponsive && isMobile) {
    return (
      <div className="ap-select lead-record__tab-selector">
        <APDropdown
          isOpen={isOpen}
          show={show}
          dismiss={dismiss}
          triggerButton={TriggerButton}
          root={null}
          isFullWidth
          className="horizontal-menu--mobile"
          menuClass="horizontal-menu__mobile-dropdown"
        >
          <>
            {items.map((item) => {
              return (
                <div
                  key={item.id}
                >
                  <button
                    className={clsx('button--unstyled', 'button--menu')}
                    onClick={() => {
                      item.onClick();
                      dismiss();
                    }}
                  >
                    {item.name}
                  </button>
                </div>
              );
            })}
          </>
        </APDropdown>
        <FontAwesomeIcon
          icon="chevron-down"
          className="select-icon"
        />
      </div>
    );
  }
  return (
    <div className={clsx('horizontal-menu', className)}>
      {items.map((item) => {
        return (
          <div
            key={item.id}
            className={clsx(
              'horizontal-menu__item',
              item.active && 'horizontal-menu__item--active',
              { 'horizontal-menu__item--show': item?.show !== false },
            )}
          >
            <button
              className={clsx('horizontal-menu__button', 'button--unstyled')}
              onClick={item.onClick}
            >
              {item.name}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default HorizontalMenu;
